import React from "react";
import {
  TableWrapper_Desktop,
  THead,
  THeadTR,
  TH,
  TableHeadText,
  TBody,
  TBodyTR,
  TableWrapper_Mobile,
  TD,
  TableBodyText,
  BodyWrapper,
  BodyRowWrapper,
  TDFirst,
} from "./Table.styles";
import {
  tableHeaderData_Desktop,
  tableHeaderData_Mobile,
  TableBodyData,
} from "./TableData";
import EmptyDashBoard from "../DashBoardComponents/EmptyDashBoard/index";
import { LuCalendarDays } from "react-icons/lu";

const Table = () => {
  const cellwidth = {
    dateCreated: "226px",
    productName: "228px",
    amount: "155px",
    PaymentType: "133px",
    TransactionID: "160px",
    status: "160px",
    icon: "57px",
  };
  return (
    <>
      <TableWrapper_Desktop>
        <THead>
          <THeadTR>
            {tableHeaderData_Desktop.map((headerData, index) => (
              <TH cellWidth={headerData.cellWidth} key={index}>
                <TableHeadText>{headerData.label}</TableHeadText>
              </TH>
            ))}
          </THeadTR>
        </THead>

        {/* <BodyWrapper>
          {TableBodyData && <TBody>
            {TableBodyData.map((tableBody, index) => (
              <BodyRowWrapper>
                <TBodyTR even={index % 2 === 0} key={index}>
                  <TDFirst cellWidth={cellwidth.dateCreated}>
                    <LuCalendarDays
                      size={"20px"}
                    />
                    <TableBodyText>{tableBody.dateCreated}</TableBodyText>
                  </TDFirst>
                  <TD cellWidth={cellwidth.productName}>
                    <TableBodyText>{tableBody.productName}</TableBodyText>
                  </TD>
                  <TD cellWidth={cellwidth.amount}>
                    <TableBodyText>{tableBody.amount}</TableBodyText>
                  </TD>
                  <TD cellWidth={cellwidth.PaymentType}>
                    <TableBodyText>{tableBody.status}</TableBodyText>
                  </TD>
                  <TD cellWidth={cellwidth.TransactionID}>
                    <TableBodyText>{tableBody.qRCode}</TableBodyText>
                  </TD>
                  <TD cellWidth={cellwidth.status}>
                    <TableBodyText>{tableBody.button1}</TableBodyText>
                  </TD>
                  <TD cellWidth={cellwidth.icon}>{tableBody.button2}</TD>
                </TBodyTR>
              </BodyRowWrapper>
            ))}
          </TBody>}
        </BodyWrapper> */}
        {/* <EmptyDashBoard />  */}
      </TableWrapper_Desktop>
      <TableWrapper_Mobile>
        <THead>
          <THeadTR>
            {tableHeaderData_Mobile.map((headerData, index) => (
              <TH cellWidth={headerData.cellWidth} key={index}>
                <TableHeadText>{headerData.label}</TableHeadText>
              </TH>
            ))}
          </THeadTR>
        </THead>

        {/* <TBody>
            <TBodyTR even={false}>
            <EmptyDashBoard/>
            </TBodyTR>
          </TBody> */}
        {/* <EmptyDashBoard /> */}
      </TableWrapper_Mobile>
    </>
  );
};

export default Table;
